import type { JSX } from "react";
import { useEffect, useState } from "react";
import { useSceneStore } from "@/state/useSceneStore";
import { useFps } from "@/hooks/useFps";
import { useTimeOfDay } from "@/hooks/useTimeOfDay";

const pad = (n: number): string => n.toString().padStart(2, "0");

export const Statusline = (): JSX.Element => {
  const section = useSceneStore((s) => s.activeSection);
  const hovered = useSceneStore((s) => s.hoveredObject);
  const quality = useSceneStore((s) => s.quality);
  const fps = useFps();
  const { band, hour, minute } = useTimeOfDay();
  const [, force] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => force((x) => x + 1), 30_000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div
      role="status"
      className="absolute inset-x-0 bottom-0 z-20 flex items-center justify-between border-t border-rule bg-bg1/80 px-4 py-1 font-mono text-xs text-ink1 backdrop-blur-sm"
    >
      <span aria-live="polite">
        adam@kotlorz:~$ {section ?? "idle"}
        {hovered ? ` :: hover ${hovered}` : ""}
      </span>
      <span aria-hidden="true">
        {fps} fps · {quality} · {band} · {pad(hour)}:{pad(minute)} local
      </span>
    </div>
  );
};
